import React, { useEffect, useRef, useState } from "react";
import "./FilterStatusSelect.scss";
import DownArrowIcon from "../../../../../components/icons/DownArrowIcon";
import { CommonEnums } from "../../../../../enums/common.enums";

const announcementOptions = Object.values(
  CommonEnums.announcement_post_types
);

const FilterAnnouncementType = ({ formik }: { formik: any }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const selectedLabel =
    announcementOptions.find(
      (option) => option.slug === formik?.values?.announcement_type
    )?.label || "Select Announcement Type";

  const handleSelect = (value: string) => {
    formik.setFieldValue("announcement_type", value);
    setDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className="announcement-agent-contain-container"
      ref={containerRef}
    >
      <div className="agent-heading">
        <p>Announcement Type</p>
      </div>

      <div className="filter-search-listing">
        <input
          type="text"
          placeholder="Select Announcement Type"
          className="filter-search-input"
          value={selectedLabel}
          onClick={() => setDropdownOpen(!dropdownOpen)}
          readOnly
        />

        <div
          className={`filter-down-arrow-icon ${dropdownOpen ? "open-box" : ""}`}
          onClick={() => setDropdownOpen(!dropdownOpen)}
        >
          <DownArrowIcon />
        </div>
      </div>

      {dropdownOpen && (
        <div className="review-list-container">
          {announcementOptions.map((option) => (
            <div
              key={option.slug}
              className={`agent-list-item ${
                formik.values.announcement_type === option.slug
                  ? "agent-list-item-active"
                  : ""
              }`}
              onClick={() => handleSelect(option.slug)}
            >
              <p className="item-profile-name">{option.label}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FilterAnnouncementType;
